import { useStripeSetupIntentStore } from '~/stores/useStripeSetupIntentStore'

// Module-side so an identity change can drop the SetupIntent without a component mounted.
export const resetSetupIntent = (): void => {
  const store = useStripeSetupIntentStore()
  store.fetchPromise = null
  store.stripeSecret = undefined
  store.setupIntentId = undefined
}
